module.exports = __webpack_public_path__ + "static/media/add-white-icon.f3057c94.svg";